import React, { useState } from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { MenuItem } from '@mui/material';
import AndrewDilks from "../images/AndrewDilks.png"
import AndrewDilksDark from "../images/AndrewDilksDark.png"
import { space3 } from "./helpers"
import useWindowDimensions from "./UseWindowDimensions";

const CustomMenuItem = ({ to, label, dark, onClick }) => (
  <MenuItem
    component={Link}
    to={to}
    onClick={onClick}
    style={{ 
      color: dark ? 'white' : '', 
      display: 'flex', 
      justifyContent: 'center' 
    }}
  >
    <b>
      {label}
    </b>
  </MenuItem>
);

const mainMenuItems = (dark, setExpandIsEnabled, isLoggedIn, userData, updateLoginState) => (
  <>
    <CustomMenuItem to="/blog" label="Blog" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem to="/found" label="Found" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem to="/changelog" label="Changelog" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem to="/experimental" label="Experimental" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem to="/comments" label="Comments" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem to="/game" label="Game" dark={dark} onClick={() => setExpandIsEnabled()} />
    <CustomMenuItem 
        to="/login" 
        label={userData?.username || "Login"}
        dark={dark} 
        onClick={() => setExpandIsEnabled()} 
      />
  </>
);

const insideNavbar = (darkModeToggle, dark, setExpandIsEnabled, snowToggle, isLoggedIn, userData, updateLoginState) => (
  <Container style={{ "display": "flex", "justifyContent": "right" }}>
    <div style={{ width: "70%" }}>
      <Navbar.Brand href="/">
        <img
          style={{ maxWidth: "100%", maxHeight: "90px" }}
          src={ dark ? AndrewDilksDark : AndrewDilks }
          alt="Andrew Dilks Logo"
        />
      </Navbar.Brand>
    </div>

    <div style={{ paddingRight: "20px" }}>
      <Navbar.Toggle
        style={{ float: "right" }}
        aria-controls="navbarScroll"
        onClick={() => setExpandIsEnabled()}
      />
    </div>

    <Navbar.Collapse id="navbarScroll">
      <Nav className="me-auto" navbarScroll >
        { mainMenuItems(dark, setExpandIsEnabled, isLoggedIn, userData, updateLoginState) }
        { darkModeToggle() }
        { snowToggle() }
      </Nav>
    </Navbar.Collapse>
  </Container>
);

const outsideNavStyle = (shouldRemoveTransparent, dark) => {
  let backgroundColor = !shouldRemoveTransparent ? "rgba(33, 37, 41, .7)" : "rgba(33, 37, 41, 1)";
  let boxShadow = "";

  if (!dark) {
    backgroundColor = !shouldRemoveTransparent ? "rgba(240, 248, 255, .7)" : "AliceBlue";
    boxShadow = "0px 5px 10px DarkSlateGray";
  }

  return {
    backgroundColor,
    maxWidth: "93%",
    borderRadius: "5px",
    boxShadow,
  };
};

const nav = (darkModeToggle, dark, expandIsEnabled, setExpandIsEnabled, shouldRemoveTransparent, snowToggle, isLoggedIn, userData, updateLoginState) => (
  <div>
    <Navbar
      expanded={expandIsEnabled}
      variant={ dark ? "dark" : "light"}
      expand="lg"
      style={ outsideNavStyle(shouldRemoveTransparent, dark) }
    >
      { insideNavbar(darkModeToggle, dark, setExpandIsEnabled, snowToggle, isLoggedIn, userData, updateLoginState) }
    </Navbar>
  </div>
);

export default function ADNavbar(props) {

  const { isDarkModeOverride: dark, darkModeToggle, shouldRemoveTransparent, snowToggle, isLoggedIn, userData, updateLoginState } = props;
  const [expandIsEnabled, setExpandIsEnabled] = useState(false);
  const { width } = useWindowDimensions();

  const toggleExpanded = () => {
    setExpandIsEnabled(!expandIsEnabled)
  }

  const small = width < 1080; // 580 comes from safari tool
  const shouldCollapse = expandIsEnabled && small;

  return (
    <div
      style={{
        // keeps navbar on top of scrolling
        position: "sticky",
        top: 0,
        // keeps navbar above everything else
        "zIndex": 1
      }}
    >
      <br/>
      <center>
        { nav(darkModeToggle, dark, shouldCollapse, toggleExpanded, shouldRemoveTransparent, snowToggle, isLoggedIn, userData, updateLoginState) }
      </center>
      { space3 }
    </div>
  )
};
